import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';

export class DialogActionConfirmation {

    public get investmentType() {
        switch (this.marketType) {
            case OrderMarketTypeEnum.Future:
                return 'contratos';
            case OrderMarketTypeEnum.Option:
                return 'opções';
            default:
                return 'ações';
        }
    }

    constructor(
        public buy: boolean,
        public orderId: string,
        public symbol: string,
        public descriptionStock: string,
        public amount: number, // quantidade
        public marketType: OrderMarketTypeEnum,
        public standardLot: number,
        public rangeMinimumPriceIncrements: number,
        public daytrade: boolean,
        public availableValueToInvest: number,
        public marketOpen?: boolean,
        public marketOpeningTime?: string,
    ) {

     }
}
